import { render } from "./MyPayment.vue?vue&type=template&id=544c2f4f&scoped=true"
import script from "./MyPayment.vue?vue&type=script&lang=js"
export * from "./MyPayment.vue?vue&type=script&lang=js"

import "./MyPayment.vue?vue&type=style&index=0&id=544c2f4f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-544c2f4f"]])

export default __exports__